import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

@Injectable()
export class ProjectCostService {
  callService: Subject<string> = new Subject();
}
